import { Record } from 'immutable';
import BestIncentivesModelV25 from 'commons-vehicle/PurchaseMethodsV25/models/BestIncentivesModelV25.js';
import ExteriorColourPhotoModelV25 from 'commons-vehicle/Vehicle/models/ExteriorColourPhotoModelV25.js';

const FinanceRecord = Record({
    kmPerYearPlan: 0,
    financePlan: '',
    paymentFrequency: 0, // 12
    tradeIn: 0, // 2000
    tradeInTaxCreditsDetails: {
        tradeIn: 0, // 2500
        tradeInTaxCredits: 0, // 374.38
        taxesDetail: '', // GST/QST
        totalTradeIn: 0, // 2874.38
    },
    lien: 0, // 1500.46
    cashDown: 0, // 2500.32
    cashDownTaxesDetails: {
        cashDown: 0,
        cashDownTaxes: 0,
        taxesDetail: '',
        totalCashDown: 0,
    },
    term: {
        term: 0, // 60
        apr: 0, // 4.99
        aprDetails: {
            initialApr: 0,
            adjustment: 0,
            totalApr: 0,
            totalInterestToPay: 0,
            totalObligation: 0,
            baseCreditCost: 0,
            baseCreditRate: 0,
            cashOnlyRebatesAdjustment: 0,
            cashOnlyRebates: 0,
            adminFeesNotChargedToCashAdjustment: 0,
            adminFeesNotChargedToCash: 0,
            totalCreditCost: 0,
            creditRate: 0,
            creditRateDisclaimer: '',
        },
        payment: 0, // 138.03
        paymentTaxes: 0, // 19.7
        taxesDetail: '', // GST / QST
        totalPayment: 0, // 157.74
        creditRate: 0, // 3.49
        creditRateDisclaimer: '', // The effective interest rate is 3.49%.
    },
    sellingPrice: 0, //  34586.68
    sellingPriceDisclaimer: '',
    incentives: new BestIncentivesModelV25(),
    feesDisclaimer: '',
    taxesDisclaimer: '', // (GST / QST), licence & registration not included
    exteriorColourPhoto: new ExteriorColourPhotoModelV25(),
});

class FinanceModelV25 extends FinanceRecord {}

export default FinanceModelV25;
